import {Client, createClient, getRepositoryEndpoint} from '@prismicio/client';
import {PrismicDocument} from '@prismicio/types';

export async function getNavbarDocument(locale: string): Promise<PrismicDocument> {
    const client = getPrismicClient();
    return client.getSingle<PrismicDocument>('malt-header', {lang: locale.toLowerCase()});
}

export function getPrismicClient(): Client {
    const {prismic} = window.__NAVBAR_UNLOGGED__;
    const repository = prismic.repository || 'malt-cms-marketing';
    const token = prismic.token || 'MC5ZcXc1bHhFQUFDRUFoZUEw.LG0S77-977-9RT4h77-9B--_ve-_vUQiNRvvv73vv70lODTvv73vv73vv73vv73vv70bT--_ve-_ve-_vW4';

    const endpoint = getRepositoryEndpoint(repository);
    return createClient(endpoint, {accessToken: token});
}
